import React from 'react';

import { Dropdown as AntDropdown, DropDownProps as AntDropdownProps } from 'antd';

const Dropdown: React.FunctionComponent<AntDropdownProps> = (props) => <AntDropdown trigger={['click']} {...props} />;

export default Dropdown;
